export const BetaBanner = () => {
  return (
    <div className="phase-banner page">
        <div className="container-fluid">
            <p>
                If you have been unable to complete this form please email your referral directly to <a href="mailto:leedsadults@leeds.gov.uk?subject=Leeds ASC Referral form">leedsadults@leeds.gov.uk</a>
            </p>
        </div>
    </div>
  )
};